import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-458dcdc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mypage py-3" }
const _hoisted_2 = { class: "section px-3 pt-4 mt-2" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-white border border-outline-color px-2 mt-1 round-4\" data-v-458dcdc6><ul class=\"mt-3 text-size-14\" data-v-458dcdc6><li class=\"list-indent\" data-v-458dcdc6>\n              ・ポイントは退会後全て削除され、復元できません。\n            </li> <li class=\"list-indent\" data-v-458dcdc6>\n              ・ウォレットに残高がある場合は退会できません。\n            </li> <li class=\"list-indent\" data-v-458dcdc6>\n              ・退会と合わせて源泉徴収票が必要な方は、アプリよりダウンロード後の退会をお願いいたします。\n            </li> <li class=\"list-indent\" data-v-458dcdc6>\n              ・労働基準法に準拠するため、一部ユーザー情報は一定期間保存されます。\n            </li></ul></div>", 1)
const _hoisted_4 = { class: "py-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      退会\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppButton, {
            variant: "primary",
            class: "mt-2",
            size: "sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLeavedQuestionnairePage()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n            上記の内容に同意する\n          ")
            ], undefined, true),
            _: 1
          })
        ])
      ]),
      _createTextVNode(),
      _createVNode(_component_AppFooter),
      _createTextVNode(),
      _createVNode(_component_BlockBack)
    ])
  ]))
}